import { Box, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SettlementsInvoicesKPIsResponseModel } from '../../../../../api/Argentia/endpoints/settlements/model/settlements'
import { envConfig } from '../../../../../config/envConfig'
import { capKpiValue } from '../../../../../helpers/numberHelper'
import { SettlementKpiItem } from '../../../components/settlementKpiItem/settlementKpiItem'

export type SettlementInvoiceKpiType =
  | 'totalInvoicesGenerated'
  | 'issuedInvoices'
  | 'nonIssuedInvoices'
  | 'totalInvoicesWithObjections'
  | 'errorSettlements'

interface SettlementKpiRightContentProps {
  kpis?: SettlementsInvoicesKPIsResponseModel
  isLoading: boolean
  /** KPI actualmente seleccionado */
  activeKpi?: SettlementInvoiceKpiType | null
  /** Handler al hacer click en un KPI */
  onKpiClick?: (kpiType: SettlementInvoiceKpiType) => void
}

export const SettlementsInvoicesKpiRightContent: React.FC<SettlementKpiRightContentProps> = ({
  kpis,
  isLoading,
  activeKpi,
  onKpiClick
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'settlementsInvoices'])
  const currentTheme = useTheme()
  const screenIsSmall = useMediaQuery(currentTheme.breakpoints.down('sm'))

  return (
    <Box style={{ height: '100%' }} display="flex" flexDirection="column">
      <Box
        style={{ height: '100%', rowGap: 16, columnGap: 16 }}
        display="flex"
        flexDirection={screenIsSmall ? 'column' : 'row'}
        flexWrap="wrap"
        justifyContent={'space-evenly'}
        alignItems="stretch"
        flexGrow={1}
      >
        <SettlementKpiItem
          id="issuedInvoices"
          isLoading={isLoading}
          title={t('settlementsInvoices:components.kpiCard.kpiItems.issuedInvoices.title')}
          value={capKpiValue(kpis?.issuedInvoices, envConfig.kpiConfig.maxDisplayValue)}
          description={t(
            'settlementsInvoices:components.kpiCard.kpiItems.issuedInvoices.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('issuedInvoices') : undefined}
          isActive={activeKpi === 'issuedInvoices'}
        />
        <SettlementKpiItem
          id="nonIssuedInvoices"
          isLoading={isLoading}
          title={t('settlementsInvoices:components.kpiCard.kpiItems.nonIssuedInvoices.title')}
          value={capKpiValue(kpis?.nonIssuedInvoices, envConfig.kpiConfig.maxDisplayValue)}
          description={t(
            'settlementsInvoices:components.kpiCard.kpiItems.nonIssuedInvoices.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('nonIssuedInvoices') : undefined}
          isActive={activeKpi === 'nonIssuedInvoices'}
        />
        <SettlementKpiItem
          id="totalInvoicesWithObjections"
          isLoading={isLoading}
          title={t(
            'settlementsInvoices:components.kpiCard.kpiItems.totalInvoicesWithObjections.title'
          )}
          value={capKpiValue(
            kpis?.totalInvoicesWithObjections,
            envConfig.kpiConfig.maxDisplayValue
          )}
          description={t(
            'settlementsInvoices:components.kpiCard.kpiItems.totalInvoicesWithObjections.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('totalInvoicesWithObjections') : undefined}
          isActive={activeKpi === 'totalInvoicesWithObjections'}
        />
        <SettlementKpiItem
          id="errorSettlements"
          isLoading={isLoading}
          title={t('settlementsInvoices:components.kpiCard.kpiItems.errorSettlements.title')}
          value={capKpiValue(kpis?.errorSettlements, envConfig.kpiConfig.maxDisplayValue)}
          description={t(
            'settlementsInvoices:components.kpiCard.kpiItems.errorSettlements.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('errorSettlements') : undefined}
          isActive={activeKpi === 'errorSettlements'}
        />
      </Box>
    </Box>
  )
}
